import React, { useContext } from 'react';

import CustomIcon from '@/components/primitive/icon';
import { Theme, ThemeContext } from '@/controllers/theme-controller';

const TerraformIcon = () => {
  const [theme] = useContext(ThemeContext);
  const iconFileName = theme === Theme.Dark ? 'icon-terraform-dark.svg' : 'icon-terraform.svg';
  return <CustomIcon src={`/assets/${iconFileName}`} isMini />;
};

export default TerraformIcon;
